module.exports = __webpack_public_path__ + "static/img/wx.046a1a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wx.jpg
// module id = 709
// module chunks = 1